import React from 'react'
import Stars from '../TestTaking/Stars'

export default function TestTakingSkill({name, stars}) {
  return (
    <div className="Skill">
      <h6>{name}</h6>
      <Stars stars={stars} overview={true}/>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/Overview/TestTakingSkill.js